import React, { useState } from "react";

const FAQS = [
  [
    "What is Xandi?",
    "Xandi is a beauty & wellness booking platform for Jamaica. Book trusted providers for mobile (at-home) or in-salon services — hair, nails, lashes, massage, skincare and more.",
  ],
  [
    "When can I start booking?",
    "Our soft launch is December 1, 2026 in Kingston & St. Catherine, with a full island-wide launch on January 4, 2027. Waitlist members get notified first.",
  ],
  [
    "Is it free to join the waitlist?",
    "Yes — completely free. Early members also receive WELCOME15 for 15% off their first booking.",
  ],
  [
    "I'm a beauty or wellness provider. How do I sign up?",
    'Choose "I\'m a Provider" above and join the waitlist. We\'ll reach out with onboarding details before launch so you\'re ready for day one.',
  ],
  [
    "Is my personal data safe?",
    "Absolutely. We comply with Jamaica's Data Protection Act (2020). Your information is encrypted and never sold.",
  ],
];

const Faq = () => {
  const [open, setOpen] = useState(null);
  return (
    <div className="faq" id="faq-list" data-testid="faq-list">
      {FAQS.map(([q, a], i) => (
        <div key={i} className={`qa ${open === i ? "open" : ""}`} data-testid={`faq-item-${i}`}>
          <button
            type="button"
            onClick={() => setOpen(open === i ? null : i)}
            data-testid={`faq-question-${i}`}
          >
            {q}
            <span className="chev">+</span>
          </button>
          <div className="ans">
            <p>{a}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Faq;
